// import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import flexibility from 'flexibility';
// import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from './modules/common/is-mobile.js';
import './modules/common/smoothScroll.js';
// import './modules/common/lazyload.js';
import './modules/common/userAgent.js';
import './modules/common/sp-menu.js';//スマホメニュー
import './modules/common/megamenu.js';//メガメニュー
import './modules/common/slidemenu.js';//スライドメニュー
import './modules/common/datepicker.js';
import './modules/common/languageSelect.js';
import './modules/common/tablefix.js';
import './modules/common/highlight.js';
import './modules/common/screenWidth.js';
import './modules/common/swiper-residence.js';
import './modules/common/swiper-imageSlider.js';
import './modules/common/accordion.js';
import './modules/common/categoryLink.js';
import './modules/common/smartphoto.js';
import './modules/common/localNav.js';
import './modules/common/gallery.swiper.js';
import './modules/common/wp_contact-form-7.js';
import './modules/common/language.js';
import './modules/common/facebook-timeline.js';
import './modules/common/sns-popup.js';
import './modules/common/imageGuard.js';
import './modules/top/swiper-hero.js';
import './modules/top/swiper-exhibition.js';
import './modules/top/animation.js';

flexibility(document.documentElement);//flexboxのie対応
objectFitImages();//object-fitのie対応
svg4everybody();//svgをieで表示

//電話番号スマホのみ掛ける
$("a[href*='tel']").on("click", function(e){
  if(!isMobile(768)){
    return false
  }
});


var hrefBase = $(".top-collection-search-button__content").attr("href");
$(".top-collection-search-select select").on("change", function(){
  // $(this).val()
  var text = $(this).find("option:selected").text();
  var val = $(this).find("option:selected").val();
  // console.log(hrefBase);
  $(".top-collection-search-select__text").text(text);
  $(".top-collection-search-button__content").attr("href", hrefBase + val);
}).trigger("change");



// import 'imagesloaded';
// import 'imports-loader?define=>false!imagesloaded/imagesloaded.js';
const imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);
// $(".exhibition-detail-main-body__image").imagesLoaded( function() {
// });
$('.exhibition-detail-main-body__image').imagesLoaded().always( function( instance ) {
  imgOffset();
  imgOffset();
//すべての画像がロードされているか、または破壊されていることが確認できた時に発火。
});

var imgOffset = function() {
  $(window).on("resize", function(){
    var content_h = $(".exhibition-detail-main-body__content").outerHeight(true);
    var image_h = $(".exhibition-detail-main-body__image").outerHeight(true);

    $(".js-imageOffset").css({
      'height': content_h - image_h + 'px'
    })
    // $(".js-screenWidth").each(function(){
    //   $(this).css({
    //     'margin-right': (-(w - $(this).outerWidth(true)) / 2) + 'px',
    //     'margin-left': (-(w - $(this).outerWidth(true)) / 2) + 'px'
    //   })
    // })
  }).trigger("resize");
}
// imgOffset();




function imageGuard(selector){

  var guard_selector = document.querySelectorAll(selector);

  for(var n = 0; n < guard_selector.length; n++){
    guard_selector[n].addEventListener("contextmenu", function(e){
      e.preventDefault();
    }, false);
  }

  var guard_style = {
    'pointer-events':'none',
    '-webkit-touch-callout':'none',
    '-moz-touch-callout':'none',
    'touch-callout':'none',
    '-webkit-user-select':'none',
    '-moz-user-select':'none',
    'user-select':'none'
  }

  Object.keys(guard_style).forEach(function(v, i, a){
    for(var n = 0; n < guard_selector.length; n++){
      guard_selector[n].style[v] = guard_style[v];
    }
  });

}


$('.js-display-limit .c-list-residence-item').each(function(i, v){
  // console.log(i);
  if(i >= 9) {
    $(this).hide();
    $(this).addClass("is-hide");
    $('.js-display-limit-show').show();
  }
});

$('.c-list-residence').next('.js-display-limit-show').find('.js-display-limit-show-button').on('click', function(){
  let item = $('.js-display-limit .c-list-residence-item.is-hide').length;
  if(item <= 8) {
    $(this).closest('.js-display-limit-show').hide();
  }
  // console.log(item);
  $('.js-display-limit .c-list-residence-item.is-hide').each(function(i, v){
    if(i <= 8) {
      $(this).show();
      $(this).removeClass("is-hide");
    }
  })
});


$('.js-display-limit .c-list-event-item').each(function(i, v){
  // console.log(i);
  if(i >= 12) {
    $(this).hide();
    $(this).addClass("is-hide");
    $('.js-display-limit-show').show();
  }
});

$('.c-list-event').next('.js-display-limit-show').find('.js-display-limit-show-button').on('click', function(){
  let item = $('.js-display-limit .c-list-event-item.is-hide').length;
  if(item <= 8) {
    $(this).closest('.js-display-limit-show').hide();
  }
  // console.log(item);
  $('.js-display-limit .c-list-event-item.is-hide').each(function(i, v){
    if(i <= 8) {
      $(this).show();
      $(this).removeClass("is-hide");
    }
  })
});


$('.js-display-limit .c-list-exhibition-item').each(function(i, v){
  // console.log(i);
  if(i >= 12) {
    $(this).hide();
    $(this).addClass("is-hide");
    $('.js-display-limit-show').show();
  }
});

$('.c-list-exhibition').next('.js-display-limit-show').find('.js-display-limit-show-button').on('click', function(){
  let item = $('.js-display-limit .c-list-exhibition-item.is-hide').length;
  if(item <= 7) {
    $(this).closest('.js-display-limit-show').hide();
  }
  // console.log(item);
  $('.js-display-limit .c-list-exhibition-item.is-hide').each(function(i, v){
    if(i <= 7) {
      $(this).show();
      $(this).removeClass("is-hide");
    }
  })
});




$('.js-display-limit .c-list-collection-item').each(function(i, v){
  // console.log(i);
  if(i >= 18) {
    $(this).hide();
    $(this).addClass("is-hide");
    $('.js-display-limit-show').show();
  }
});

$('.c-list-collection').next('.js-display-limit-show').find('.js-display-limit-show-button').on('click', function(){
  let item = $('.js-display-limit .c-list-collection-item.is-hide').length;
  if(item <= 11) {
    $(this).closest('.js-display-limit-show').hide();
  }
  // console.log(item);
  $('.js-display-limit .c-list-collection-item.is-hide').each(function(i, v){
    if(i <= 11) {
      $(this).show();
      $(this).removeClass("is-hide");
    }
  })
});

// document.addEventListener("DOMContentLoaded", function() {
//   imageGuard('img');
// });
//
// $('.l-header__logo').append('<img src="/assets/img/common/logo.png">');

// const hoge = val => val + 1;
// console.log(hoge(1));
